import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Route wrapper that requires authentication.
 * - Redirects to /login if not authenticated.
 * - If requireAdmin is true, also checks is_admin and redirects non-admins to /results.
 */
function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, profile, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={styles.spinner}></div>
        <p style={styles.loadingText}>Loading...</p>
      </div>
    );
  }

  // Not logged in — go to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin route but user is not admin — go to portal
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/results" replace />;
  }

  return children;
}

const styles = {
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#F8F9FA',
  },
  spinner: {
    width: 40,
    height: 40,
    border: '4px solid #E0E0E0',
    borderTop: '4px solid #2D7A4E',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: 16,
    color: '#6B7A8F',
    fontSize: 16,
    fontFamily: 'Inter, sans-serif',
  },
};

export default ProtectedRoute;
